import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { LegitimationProcess } from './LegitimationProcess';
import { LegitimationSuccess } from './LegitimationSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep10() {
  // Context
  const { step10SubStep, setStep10SubStep, clearActivationStates } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: page titles
  const { globalPageTitle } = getGlobalMetaTitles();
  const activationChooseLegitimationPageTitle = tA11yTranslate(
    'ek_global_meta_title_legitimation'
  ).content;
  const isTranslationReady = keyValueValidation(activationChooseLegitimationPageTitle,'ek_global_meta_title_legitimation')

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    return `${globalPageTitle} - ${activationChooseLegitimationPageTitle}`;
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step10SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // reset substep handling
    setStep10SubStep(0);
  }, [setStep10SubStep]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      clearActivationStates(true);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [clearActivationStates]);

  const renderStep8SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <LegitimationProcess />;
      case 1:
        return <LegitimationSuccess />;
      default:
        return <LegitimationProcess />;
    }
  };

  // return renderStep8SubSteps(step10SubStep);
  return (
    <>
       <Meta title={getPageTitle()} key={`meta-key-${step10SubStep}`} />
      {renderStep8SubSteps(step10SubStep)}
    </>
  );
}

export default ActivationStep10;
